import { render, staticRenderFns } from "./LinkDetail.vue?vue&type=template&id=3d6b5dc1&scoped=true&"
import script from "./LinkDetail.vue?vue&type=script&lang=ts&"
export * from "./LinkDetail.vue?vue&type=script&lang=ts&"
import style0 from "./LinkDetail.vue?vue&type=style&index=0&id=3d6b5dc1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6b5dc1",
  null
  
)

export default component.exports